import script from "./AppHeaderBreadCrumb.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppHeaderBreadCrumb.vue?vue&type=script&lang=ts&setup=true"

import "./AppHeaderBreadCrumb.vue?vue&type=style&index=0&id=afa38ba4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afa38ba4"]])

export default __exports__